import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dreamWorldProvider from "../DreamWorldProvider";
import { useDispatch } from "react-redux";
import { setUserGlobalData } from "../store/dreamworldSlice";
import LoadingIndicator from "../components/ui/LoadingIndicator";
import LandingPage from "./LandingPage";
import { isDreamLive } from "../utils/isDreamLive";

const EntryPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [showLanding, setShowLanding] = useState(false);

  useEffect(() => {
    const checkLoginState = async () => {
      const isSignedIn = localStorage.getItem("isSignedIn");
      if (isSignedIn === "true") {
        try {
          let userGlobalData;
          if (isDreamLive()) {
            userGlobalData = await dreamWorldProvider.autoSignInFromSession();
          } else {
            userGlobalData = await dreamWorldProvider.signInWithPi();
          }
          dispatch(setUserGlobalData(userGlobalData));
          navigate("/home");
        } catch (error) {
          console.error("Auto sign-in failed", error);
          localStorage.removeItem("isSignedIn");
          setShowLanding(true);
        }
      } else {
        setShowLanding(true);
      }
      setLoading(false);
    };

    checkLoginState();
  }, [navigate, dispatch]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-950">
        <LoadingIndicator />
      </div>
    );
  }

  if (showLanding) {
    return <LandingPage />;
  }

  return null;
};

export default EntryPage;
